import React, { useState } from "react";
import Layout from "../Layout";
import Report from "../Components/Attendances/Report";

function AttendancesReport() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Attendance Report</h1>
          </div>

          <Report comp={comp} onChange={handleChange} rowData={rowData} />
        </section>
      </div>
    </Layout>
  );
}

export default AttendancesReport;
